// import React, { useState, useEffect } from 'react';

import PlaybackLine from './PlaybackLine';

import play_circle from '../../Images/play-circle-bold.svg';
import pause_circle from '../../Images/pause-circle-bold.svg';
import musical from '../../Images/musical/6.jpeg';

import PlacementData from '../Data/PlacementData';
import FilmScoreData from '../Data/FilmScoreData';

const BottomPlayBar = ({width,playing,playPressed,route,audioRef,playBack,dimensions}) => {

	// useEffect(()=>{console.log(playing)},[playing]);

	function playClicked() {
		playPressed(playing.id,playing.i);
	}

	if(playing.id !== undefined){
		return(
			<div className='fixed' style={{bottom:0,left:0,right:0,height:100,borderTop:'1px solid rgba(255,255,255,0.1)',background:'rgb(17,20,34)',color:'white',zIndex:200}}>
				{playing.id !== undefined
					? <div style={{width:width,margin:'auto',height:80-8}} className='flexCenter '>
						<div className='flexCenter relative' style={{width:30,zIndex:20}}>
							{playing.play === true
								? <img src={pause_circle} alt='pause_circle' style={{height:32}} className='pointer' onClick={playClicked} />
								: <img src={play_circle} alt='play_circle' style={{height:32}} className='pointer' onClick={playClicked} />
							}
						</div>
						{route === '/placements'
							? PlacementData[playing.i] !== undefined
								? <div style={{width:40,height:40,overflow:'hidden',borderRadius:3,marginLeft:-36,border:'1px solid rgba(255,255,255,0.2)',
										background:'black'}} className='flexCenter'>
									<img src={PlacementData[playing.i].thumbnail} alt='plwnfwe' style={{width:40,opacity:0.5}} />
								</div>
								: null
							: null
						}
						{route === '/film'
							? FilmScoreData[playing.i] !== undefined
								? <div style={{width:40,height:40,overflow:'hidden',marginLeft:10,border:'1px solid rgba(255,255,255,0.2)'}} className='flexCenter'>
									<img src={FilmScoreData[playing.i].thumbnail} alt='plwnfwe' style={{width:44}} />
								</div>
								: null
							: null
						}
						{route === '/musical'
							? <div style={{width:40,height:40,overflow:'hidden',marginLeft:10,border:'1px solid rgba(255,255,255,0.2)'}} className='flexCenter'>
								<img src={musical} alt='plwnfwe' style={{height:40}} />
							</div>
							: null
						}
						<div style={{marginLeft:10}}>{playing.id}</div>

						
					</div>
					: null
				}
				<div style={{width:width,margin:'auto'}}><PlaybackLine audioRef={audioRef} playBack={playBack} width={width} dimensions={dimensions} height={8} /></div>
			</div>
		)
	}
	return null
}

export default BottomPlayBar;